import React from 'react';
import { User, Mail, Phone } from 'lucide-react';
import PremiumDatePicker from '../PremiumDatePicker';

const GlobalProfileTab = ({ profileData, setProfileData, handleUpdateProfile, updateLoading, t }) => {
    return (
        <div className="fade-in" style={{ paddingBottom: '7rem' }}>
            <div className="card" style={{
                padding: '2.5rem 1.5rem',
                borderRadius: '35px',
                background: 'white',
                boxShadow: '0 10px 40px rgba(0,0,0,0.05)',
                border: '1px solid rgba(0,0,0,0.02)'
            }}>
                {/* Profile Header */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '1.25rem', marginBottom: '2.5rem' }}>
                    <div>
                        <h3 style={{ fontSize: '1.25rem', fontWeight: 800, color: '#1a1412', marginBottom: '4px' }}>Profili Düzenle</h3>
                        <p style={{ fontSize: '0.8125rem', color: 'var(--text-muted)' }}>Kişisel bilgilerinizi buradan güncelleyebilirsiniz.</p>
                    </div>
                </div>

                <form onSubmit={handleUpdateProfile} style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                            <label style={{ fontSize: '0.75rem', fontWeight: 700, color: 'var(--text-main)', opacity: 0.7 }}>Ad</label>
                            <div style={{ position: 'relative' }}>
                                <User size={16} style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', opacity: 0.4 }} />
                                <input
                                    type="text"
                                    value={profileData.firstName}
                                    onChange={e => setProfileData({ ...profileData, firstName: e.target.value })}
                                    placeholder="Adınız"
                                    style={{ width: '100%', padding: '12px 12px 12px 40px', background: 'var(--bg-main)', border: '1px solid var(--border)', borderRadius: '12px', fontSize: '0.875rem', color: 'inherit' }}
                                    required
                                />
                            </div>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                            <label style={{ fontSize: '0.75rem', fontWeight: 700, color: 'var(--text-main)', opacity: 0.7 }}>Soyad</label>
                            <div style={{ position: 'relative' }}>
                                <User size={16} style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', opacity: 0.4 }} />
                                <input
                                    type="text"
                                    value={profileData.lastName}
                                    onChange={e => setProfileData({ ...profileData, lastName: e.target.value })}
                                    placeholder="Soyadınız"
                                    style={{ width: '100%', padding: '12px 12px 12px 40px', background: 'var(--bg-main)', border: '1px solid var(--border)', borderRadius: '12px', fontSize: '0.875rem', color: 'inherit' }}
                                    required
                                />
                            </div>
                        </div>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        <label style={{ fontSize: '0.75rem', fontWeight: 700, color: 'var(--text-main)', opacity: 0.7 }}>E-posta</label>
                        <div style={{ position: 'relative' }}>
                            <Mail size={16} style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', opacity: 0.4 }} />
                            <input
                                type="email"
                                value={profileData.email}
                                onChange={e => setProfileData({ ...profileData, email: e.target.value })}
                                placeholder="ornek@email.com"
                                style={{ width: '100%', padding: '12px 12px 12px 40px', background: 'var(--bg-main)', border: '1px solid var(--border)', borderRadius: '12px', fontSize: '0.875rem', color: 'inherit' }}
                            />
                        </div>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        <label style={{ fontSize: '0.75rem', fontWeight: 700, color: 'var(--text-main)', opacity: 0.7 }}>Telefon</label>
                        <div style={{ position: 'relative' }}>
                            <Phone size={16} style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', opacity: 0.4 }} />
                            <input
                                type="tel"
                                value={profileData.phone}
                                onChange={e => setProfileData({ ...profileData, phone: e.target.value })}
                                placeholder="5XX XXX XX XX"
                                style={{ width: '100%', padding: '12px 12px 12px 40px', background: 'var(--bg-main)', border: '1px solid var(--border)', borderRadius: '12px', fontSize: '0.875rem', color: 'inherit' }}
                            />
                        </div>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        <label style={{ fontSize: '0.75rem', fontWeight: 700, color: 'var(--text-main)', opacity: 0.7 }}>Doğum Tarihi</label>
                        <PremiumDatePicker
                            value={profileData.birthday}
                            onChange={val => setProfileData({ ...profileData, birthday: val })}
                        />
                    </div>

                    <button
                        type="submit"
                        disabled={updateLoading}
                        style={{
                            marginTop: '1.5rem',
                            width: '100%',
                            padding: '16px',
                            background: '#73523d',
                            color: 'white',
                            border: 'none',
                            borderRadius: '16px',
                            fontSize: '1rem',
                            fontWeight: 800,
                            cursor: updateLoading ? 'not-allowed' : 'pointer',
                            opacity: updateLoading ? 0.7 : 1,
                            boxShadow: '0 10px 30px rgba(115, 82, 61, 0.2)'
                        }}
                    >
                        {updateLoading ? 'Güncelleniyor...' : t('customers.updateBtn', 'Bilgilerimi Güncelle')}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default GlobalProfileTab;
